import { useState, useEffect, useCallback, useMemo } from 'react'
import photos from '../../data/photos'
import './index.scss'

const shuffle = arr => {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

const pad = n => String(n).padStart(2, '0')

const Photos = () => {
  const [open, setOpen] = useState(-1)
  const shuffled = useMemo(() => shuffle(photos), [])

  const close = useCallback(() => {
    document.body.style.overflow = ''
    setOpen(-1)
  }, [])

  const openAt = useCallback(i => {
    document.body.style.overflow = 'hidden'
    setOpen(i)
  }, [])

  const next = useCallback(e => {
    e?.stopPropagation()
    setOpen(i => (i + 1) % shuffled.length)
  }, [shuffled.length])

  const prev = useCallback(e => {
    e?.stopPropagation()
    setOpen(i => (i - 1 + shuffled.length) % shuffled.length)
  }, [shuffled.length])

  useEffect(() => {
    const onKey = e => {
      if (open < 0) return
      if (e.key === 'Escape') close()
      else if (e.key === 'ArrowRight') next()
      else if (e.key === 'ArrowLeft') prev()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, close, next, prev])

  // cleanup on unmount
  useEffect(
    () => () => {
      document.body.style.overflow = ''
    },
    [],
  )

  return (
    <div className='ph-root'>
      {/* ── Title row ─────────────────────────────────────── */}
      <div className='ph-title-row'>
        <div className='ph-title-copy'>
          <div className='ph-eyebrow'>( PHOTOS )</div>
          <div className='ph-lead'>
            <span className='ph-lead__bright'>A running collection of frames I've shot.</span>{' '}
            Travel, brand work, good light, and random moments I wanted to hang onto.
          </div>
        </div>
        <div className='ph-count'>{pad(shuffled.length)} frames · click to enlarge</div>
      </div>

      {/* ── Masonry grid ──────────────────────────────────── */}
      <div className='ph-grid'>
        {shuffled.map((p, i) => (
          <div key={p.src + i} className='ph-item' onClick={() => openAt(i)}>
            <img src={p.src} alt='' loading='lazy' />
          </div>
        ))}
      </div>

      {/* ── Lightbox ──────────────────────────────────────── */}
      {open >= 0 && (
        <div className='lb-backdrop' onClick={close}>
          <div className='lb-counter'>
            {pad(open + 1)} / {pad(photos.length)}
          </div>

          <button className='lb-btn lb-btn--close' onClick={close}>
            ✕
          </button>
          <button className='lb-btn lb-btn--prev' onClick={prev}>
            ‹
          </button>
          <button className='lb-btn lb-btn--next' onClick={next}>
            ›
          </button>

          <div className='lb-img-wrap' onClick={e => e.stopPropagation()}>
            <img key={photos[open].src} src={shuffled[open].src} alt='' className='lb-img' />
          </div>
        </div>
      )}
    </div>
  )
}

export default Photos
